import React, { useEffect, useState } from "react";
import { FarmListNavStyled, NoResults, MapButton, DrawerButton, } from "./FarmListNavStyled";
import FarmListNavItem from "./FarmListNavItem";
import MapFilters from "./MapFilters";
import { ReactSVG } from "react-svg";
import { useEnvContext } from "@gw/env-context";
import { imgs } from "@gw/theming";
var FarmListNav = function (_a) {
    var farmers = _a.farmers, activeFarmer = _a.activeFarmer, setActiveFarmer = _a.setActiveFarmer, isMobile = _a.isMobile, handleZoom = _a.handleZoom, setSlideIndex = _a.setSlideIndex, visibleFarmers = _a.visibleFarmers, setVisibleFarmers = _a.setVisibleFarmers, filteredFarmers = _a.filteredFarmers, setFilteredFarmers = _a.setFilteredFarmers, resetMap = _a.resetMap;
    var imgsFolder = useEnvContext().imgsFolder;
    var activeFarmerIndex = localStorage.getItem("activeFarmerIndex")
        ? parseInt(localStorage.getItem("activeFarmerIndex"))
        : null;
    var _b = useState(true), showFarmers = _b[0], setShowFarmers = _b[1];
    useEffect(function () {
        setVisibleFarmers(farmers.filter(function (farmer) { return farmer.isVisible; }));
        setFilteredFarmers(farmers.filter(function (farmer) { return farmer.isVisible; }));
    }, [farmers, setFilteredFarmers, setVisibleFarmers]);
    useEffect(function () {
        if (isMobile) {
            if (activeFarmerIndex) {
                setActiveFarmer(farmers[activeFarmerIndex]);
                setSlideIndex(activeFarmerIndex);
            }
            else {
                setActiveFarmer(farmers[0]);
            }
        }
    }, [isMobile, farmers, activeFarmerIndex, setActiveFarmer, setSlideIndex]);
    var handleReset = function () {
        setFilteredFarmers(farmers.filter(function (farmer) { return farmer.isVisible; }));
    };
    var handleFilter = function (results) {
        setFilteredFarmers(results);
    };
    return (React.createElement(FarmListNavStyled, null,
        showFarmers ? (React.createElement("div", { className: "nav-container" },
            React.createElement(MapFilters, { data: farmers, filteredFarmers: filteredFarmers, visibleFarmers: visibleFarmers, filterCallback: handleFilter, resetCallback: handleReset, resetMap: resetMap, handleZoom: handleZoom }),
            (filteredFarmers === null || filteredFarmers === void 0 ? void 0 : filteredFarmers.length) > 0 ? (React.createElement("div", { className: "slider-background" }, filteredFarmers.map(function (farmer) {
                var id = farmer.id, name = farmer.name, logo_img_url = farmer.logo_img_url, city = farmer.city, state = farmer.state, species_data = farmer.species_data, isVisible = farmer.isVisible;
                return (isVisible && (React.createElement(FarmListNavItem, { key: "farm-" + id, id: id, name: name, image: logo_img_url, city: city, state: state, species_data: species_data, isActive: (activeFarmer === null || activeFarmer === void 0 ? void 0 : activeFarmer.id) == id, onMouseEnter: function () {
                        setActiveFarmer(farmer);
                    }, onMouseLeave: function () {
                        setActiveFarmer(null);
                    } })));
            }))) : (React.createElement(NoResults, null,
                React.createElement("div", { className: "no-results" },
                    React.createElement(ReactSVG, { className: "logoutIcon", src: imgsFolder + "/" + imgs.icons.iconNoResults }),
                    React.createElement("div", null,
                        React.createElement("h3", null, "Uh oh! There aren't any ocean farms here!."),
                        React.createElement("h3", null, "Get to a coast"))))))) : (React.createElement(DrawerButton, { onClick: function () { return setShowFarmers(true); } },
            React.createElement("div", { className: "button-dash" }), "See " + (filteredFarmers.length === farmers.length
            ? "all"
            : filteredFarmers.length) + " results")),
        showFarmers && (React.createElement(MapButton, { onClick: function () { return setShowFarmers(false); } },
            React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.iconMap }),
            "Map"))));
};
export default FarmListNav;
//# sourceMappingURL=FarmListNav.js.map